// Valida el rut con su cadena completa "XXXXXXXX-X"
const validaRut = function (rutCompleto) {
  if (!rutCompleto) return false;
  rutCompleto = rutCompleto.replace(/[.]/g, "");
  if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(rutCompleto)) {
    return false;
  }
  let tmp = rutCompleto.split('-');
  let [cuerpo, dv] = tmp;
  // Calcular Dígito Verificador
  let suma = 0;
  let multiplo = 2;

  // Para cada dígito del Cuerpo
  for (let i = 1; i <= cuerpo.length; i++) {
    // Obtener su Producto con el Múltiplo Correspondiente
    let index = multiplo * rutCompleto.charAt(cuerpo.length - i);
    // Sumar al Contador General
    suma = suma + index;
    // Consolidar Múltiplo dentro del rango [2,7]
    if (multiplo < 7) { multiplo = multiplo + 1; } else { multiplo = 2; }
  }

  // Calcular Dígito Verificador en base al Módulo 11
  let dvEsperado = 11 - (suma % 11);
  // Casos Especiales (0 y K)
  dv = (dv === 'K') ? 10 : dv;
  dv = (Number(dv) === 0) ? 11 : dv;

  return dvEsperado === Number(dv);
};

const formatRut = function (rut) {
  if (rut.length > 11) return rut.substring(0, 11);
  var actual = rut.replace(/^0+/, "");
  if (actual !== '' && actual.length > 1) {
    var sinPuntos = actual.replace(/\./g, "");
    var actualLimpio = sinPuntos.replace(/-/g, "");
    var pv = actualLimpio.substring(0, actualLimpio.length - 1);
    var dv = actualLimpio.substring(actualLimpio.length - 1);
    return pv + "-" + dv;
  }
  return rut
}

export default { validaRut, formatRut };



// WEBPACK FOOTER //
// ./src/utils/rut.js